import "./publications-page.css"

import publicationsJson from "./publications.json"
import PublicationCard from "./publication_card.jsx"

const createYearToPublicationMapping = (filteredPublications) => {
    // Create new JS object with each year mapped to all the publications
    // published in that year
    const yearToPublication = []
    for (const publication of filteredPublications) {
        const publicationsOfYear = yearToPublication.find(
            mapping => mapping.year === publication.year);
        // initialize year to publications object if year hasn't yet been displayed
        if (publicationsOfYear === undefined) {
            yearToPublication.push(
                {   
                    year: publication.year,
                    publications: [ publication ]
                }
            );
        } else {
            // add publication to the object with the proper year
            publicationsOfYear["publications"].push(publication);
        }
    }
    return yearToPublication;
}

export default function Publications() {
    const publications = createYearToPublicationMapping(publicationsJson);

    return (
        <div className="publications-page">
            <div className="publications-layout">
                <aside className="publications-photo-column">
                    <img
                        className="publications-photo"
                        src={require('../resources/img/publications_photo.png')}
                        alt="Publications page portrait"
                    />
                </aside>
                <div className="publications-content">
                    <h1>Publications</h1>
                    {publications.map((yearToPublication, index) => (
                        <div className="year-publications-category" key={index}>
                            <h1>{yearToPublication.year}</h1>
                            <div className="publications-in-category">
                                {yearToPublication.publications.map((publicationEntry) => (
                                    <PublicationCard
                                        publication={publicationEntry}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
